import {Injectable} from '@angular/core';
import {LocalizeService} from '@services/helpers/localize/localize.service';
import moment from "moment-timezone";

/**
 * Put any general calculations / helpers / formatter functions in this service
 */

@Injectable({
  providedIn: 'root'
})
export class GeneralHelperService {

  today: Date = null;

  constructor(private localize: LocalizeService) {
  }

  dobStringToAge(dobStr: string): string {
    const dobMoment = moment(dobStr);
    if (!dobMoment.isValid()) {
      return '';
    }
    const age = moment().diff(dobMoment, 'years');

    return String(age);
  }
}
